import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { confirmModal } from '@/components/ui/modal'
import { useDeleteTask } from '../../taskApi'
import type { Project, Task } from '../../types'
import { toastError } from '../../ui'

/** Onay modalı + silme; alt görev ve bağımlılık etkisini açıklamada söyler. */
export function useTaskDelete(project: Project) {
  const { t } = useTranslation()
  const remove = useDeleteTask(project.id)
  return async (task: Task) => {
    const subtasks = project.tasks.filter((x) => x.parentId === task.id).length
    const ok = await confirmModal({
      title: t('projects.tasks.deleteTitle'),
      description: t('projects.tasks.deleteBody', { key: task.key, title: task.title, count: subtasks }),
      confirmLabel: t('common.delete'),
      destructive: true,
    })
    if (!ok) return false
    try {
      await remove.mutateAsync(task.id)
      toast.success(t('projects.tasks.deleted'))
      return true
    } catch (e) {
      toastError(e)
      return false
    }
  }
}
